var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 12.1656C1 12.2122 1.03778 12.25 1.08437 12.25L20.206 12.25C20.2804 12.25 20.3184 12.3392 20.2669 12.3928L13.7523 19.1789C13.7209 19.2116 13.721 19.2633 13.7525 19.2959L15.3391 20.937C15.3724 20.9714 15.4275 20.9713 15.4607 20.9368L24.9439 11.0584C24.9752 11.0258 24.9752 10.9742 24.9439 10.9416L15.4609 1.0634C15.4277 1.02881 15.3723 1.02881 15.3391 1.0634L13.764 2.70412C13.7327 2.73675 13.7327 2.78827 13.764 2.82093L20.2672 9.60725C20.3186 9.6609 20.2806 9.75 20.2063 9.75L1.08438 9.75C1.03778 9.75 1 9.78778 1 9.83437L1 12.1656Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.421875
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.dc9d0916caa4182f933be835a8113987.svg";
export { ForwardRef as ReactComponent };